import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

import { ChartTooltip } from '../chart-tooltip/chart-tooltip.component';
import { ChartLegend } from '../chart-legend/chart-legend.component';
import { style } from './bar-chart.module.css';

interface Props {
  data: ({ x: Date; y: Record<string, number> })[];
  showLegend?: boolean;
  formatX: (value: Date) => string;
  formatY: (value: number) => string;
  bars: {
    key: string;
    title: string;
    color: string;
  }[];
}

export function BarChart(props: Props) {

  const {
    data,
    bars,
    showLegend = false,
    formatX,
    formatY
  } = props;

  return (
    <ResponsiveContainer initialDimension={{ width: 100, height: 100 }}>
      <RechartsBarChart data={data.map(item => ({ x: item.x, ...item.y }))}>
        <CartesianGrid 
          vertical={false} 
          stroke={'var(--color-neutral-200)'} 
          strokeWidth={0.5}/>
        <XAxis
          dataKey='x'
          axisLine={false}
          tickLine={false}
          tick={{ className: style.axisTick }}
          tickFormatter={formatX}
          dy={10}/>
        <YAxis
          width='auto'
          axisLine={false}
          tickLine={false}
          tick={{ className: style.axisTick }}
          tickFormatter={formatY}/>
        <Tooltip 
          cursor={{ fill: 'var(--color-neutral-100)' }}
          content={
            <ChartTooltip
              formatLabel={formatX}
              formatValue={formatY}/>
          }/>
        {showLegend && (
          <Legend content={<ChartLegend />}/>
        )}
        {bars.map((bar) => (
          <Bar
            key={bar.key}
            name={bar.title}
            dataKey={bar.key}
            fill={bar.color}
            radius={[4, 4, 0, 0]}/>
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
